<template>
  <div class="main-container">
    <!-- Author: Vaishnavi
      Date: 12/12/2019
      Issue Description: Breadcrumb alignment -->
        <breadcrumb :list="breadcrumbList" />
    <div class="margintop-32" />
    <tl-header type="h1">
      <div class="main-header">Loan payment summary</div>
    </tl-header>
    <section class="main-content-section">
      <div class="row">
        <div class="col-3">
          <txt label="Entity Name" name="entity_name" placeholder="Lakshmi Services" v-model="filterModel.entityName" />
        </div>
        <div class="col-3">
          <tl-select label="Paygroups" :options="paygroupList" />
        </div>
      </div>
      <div class="row margintop-10">
        <div class="col-3">
          <tl-select label="Department" :options="departmentList" />
        </div>
        <div class="col-3">
          <tl-select label="Cost Center" :options="costCenterList" />
        </div>
      </div>
      <btn text="Apply Filters" type="secondary" class="marginbot-20 margin-top-20 " v-on:click="applyFilters" />
      <div class="row">
        <div class="col-4">
          <search-dropdown :employeeData="employeeLoanSummaryList" @empselected="(emp)=>selectedEmp(emp)" />
        </div>
      </div>
      <data-table class="margin-top-30 " :columns="tableColumns" :tableData="selectedEmployee.length ? selectedEmployee:employeeLoanSummaryList"
        :showinrow="false">
        <template v-slot:rowcontent="slotprops">
          <div class="action-section" v-if="slotprops.value.column.key=='actions'">
            <img src="@/assets/group-2.png" @click="dropdown(slotprops)" alt="actionIcon" />
            <ul class="action-menu" v-show="employeeLoanSummaryList[slotprops.value.index].showDropDown">
              <li>
                <span class>View/Edit</span>
              </li>
              <li>
                <span class>Delete</span>
              </li>
            </ul>
          </div>
        </template>
      </data-table>
    </section>
    <div class="btn-group">
      <bottom-action-container>
        <btn-grp slot="end">
          <btn text="Close" type="secondary" class @click="close"></btn>
        </btn-grp>
      </bottom-action-container>
    </div>
  </div>
</template>
<script>
  import SearchDropdown from "@/components/TlSearchDropdown.vue";
  export default {
    components: {
      SearchDropdown
    },
    data() {
      return {
        breadcrumbList:[
                    {
                        name: "Organisation",
                        url: `/dashboard/${this.$route.params.entity_index}/organisation`
                    },
                    {
                        name: "Utilities",
                        url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
                    },
                    {
                        name: "Loan Payment Summary",
                        url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/loanpaymentsummary`
                    }
                ],
        paygroupList: [],
        costCenterList: [],
        departmentList: [],
        tableColumns: [
          {
            label: "SINo",
            key: "sino"
          },
          {
            label: "Code",
            key: "code"
          },
          {
            label: "Name",
            key: "name"
          },
          {
            label: "Disbursement Date",
            key: "disbursementDate"
          },
          {
            label: "Start Date",
            key: "startDate"
          },
          {
            label: "Loan Amount",
            key: "loanAmount"
          },
          {
            label: "Recovery type",
            key: "recoveryType"
          },
          {
            label: "Interest type",
            key: "interestType"
          },
          {
            label: "Loan Status",
            key: "loanStatus"
          },
          {
            label: "Actions",
            key: "actions"
          }
        ],
        employeeLoanSummaryList: [
          {
            sino: "1",
            code: "RC1234",
            name: "Roxie Schmidt",
            disbursementDate: "08 Jun 2019",
            startDate: "23 Sep 2019",
            loanAmount: "₹2000",
            recoveryType: "Monthly",
            interestType: "Fixed",
            loanStatus: "Open",
            actions: "",
            showDropDown: false
          },
          {
            sino: "2",
            code: "RC1004",
            name: "John Doe",
            disbursementDate: "08 Aug 2019",
            startDate: "20 Nov 2019",
            loanAmount: "₹4000",
            recoveryType: "Monthly",
            interestType: "Fixed",
            loanStatus: "Closed",
            actions: "",
            showDropDown: false
          },
          {
            sino: "3",
            code: "RC1944",
            name: "James Duke",
            disbursementDate: "08 May 2019",
            startDate: "15 Dec 2019",
            loanAmount: "₹3000",
            recoveryType: "Monthly",
            interestType: "Fixed",
            loanStatus: "Open",
            actions: "",
            showDropDown: false
          },
          {
            sino: "4",
            code: "RC2944",
            name: "Harvey Spector",
            disbursementDate: "08 May 2016",
            startDate: "15 Dec 2017",
            loanAmount: "₹3000",
            recoveryType: "Monthly",
            interestType: "Fixed",
            loanStatus: "Open",
            actions: "",
            showDropDown: false
          },
          {
            sino: "5",
            code: "RC1144",
            name: "Mike Ross",
            disbursementDate: "02 May 2018",
            startDate: "15 Sep 2019",
            loanAmount: "₹2000",
            recoveryType: "Monthly",
            interestType: "Fixed",
            loanStatus: "Open",
            actions: "",
            showDropDown: false
          }
        ],
        selectedEmployee: [],
        filterModel: {
          entityName: ""
        }
      };
    },
    methods: {

      routeToMainStep() {
        this.$router.push({
          path: `/dashboard/${this.$route.params.entity_index}/organisation`
        });
      },
      routeToSubStep() {
        this.$router.push({
          path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
        });
      },

      applyFilters() { },
      dropdown(item) {
        //console.log(item);
        this.employeeLoanSummaryList.forEach((element, index) => {
          if (item.value.index != index) {
            element.showDropDown = false;
          }
        });
        this.employeeLoanSummaryList[item.value.index].showDropDown = !this
          .employeeLoanSummaryList[item.value.index].showDropDown;
      },
      selectedEmp(item) {
        this.selectedEmployee = [item];
        //console.log(item);
      },
      close() {
        this.selectedEmployee = [];
      }
    }
  };
</script>
<style lang="scss" scoped>
@import "@/scss/components/margins.scss";  //margins
  .row {
    margin-bottom: 10px;
  }

  .margin-top-20 {
    margin-top: 20px;
  }

  .margin-top-30 {
    margin-top: 30px;
  }


  .action-section {
    margin: 0px;
    text-align: center;

    img {
      width: auto;
    }
    .action-menu {
      top: 0px;
      right: 54px;
      left: -182px;
      li {
        padding: 0px;
        padding: 10px 25px;
        font-weight: 500;
        &:not(:last-child) {
          border-bottom: solid 1px #97979759;
        }
      }
    }
  }

  .main-content-section {
    padding-top: 18px;
  }
</style>